import PropTypes from 'prop-types';

const InfoBlock = ({ title, children }) => (
  <section>
    <h4 className="font-bold my-2">{title}</h4>
    {children}
  </section>
);

InfoBlock.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default InfoBlock;
